import {getRequest, postRequest, deleteRequest} from "../api";
import {mapReqOptions} from "../utils";

export const createRelationship = (
  targetId,
  sourceId,
  type,
  relationshipType
) => {
  const postData = {
    source_ref: sourceId,
    target_ref: targetId,
    type,
    relationship_type: relationshipType
  };
  return postRequest(`/relationship`, postData, {
    serverOptions: {privateURL: true}
  });
};

export const getRelationships = (targetId, sourceId, options = {}) => {
  const query = [];

  // check https: for the full id, but * for scrubbed

  if (targetId) {
    if (targetId.includes("https://")) {
      query.push(`target_ref:"${targetId}"`);
    } else {
      query.push(`target_ref:*${targetId}`);
    }
  }

  if (sourceId) {
    if (sourceId.includes("https://")) {
      query.push(`source_ref:"${sourceId}"`);
    } else {
      query.push(`source_ref:*${sourceId}`);
    }
  }

  return getRequest(
    `/relationship/search`,
    {query: query.join(" "), ...mapReqOptions(options)},
    {
      serverOptions: {privateURL: true}
    }
  );
};

export const deleteRelationships = (targetId, sourceId) => {
  let params = "";
  targetId = targetId ? encodeURIComponent(targetId) : null;
  sourceId = sourceId ? encodeURIComponent(sourceId) : null;
  if (targetId && sourceId) {
    params += `target_ref=${targetId}&source_ref=${sourceId}`;
  } else if (sourceId) {
    params += `source_ref=${sourceId}`;
  } else if (targetId) {
    params += `target_ref=${targetId}`;
  }
  
  return deleteRequest(`/relationship/search/${params}`, null, {
    serverOptions: {privateURL: true}
  });
};

export const deleteRelationship = relationshipId => {
  return deleteRequest(`/relationship/${relationshipId}`, null, {
    serverOptions: {privateURL: true}
  });
};
